import React, { useContext, useEffect, useRef, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Alert from '@mui/material/Alert';
import { confirm } from 'venuescanner-js/vanilla/components/confirm';
import MessageInput from '../MessageInput/MessageInput';
import { MessageInputContext } from '../MessageInput/MessageInputContext';
import templatesAPI from './TemplatesAPI';
import IconButton from './IconButton';
import IconTrashcan from 'venuescanner-js/react/components/Objects/Icons/IconTrashcan';
import PrimaryButton from '../../../../Buttons/PrimaryButton';
import SecondaryButton from '../../../../Buttons/SecondaryButton';
import templateQueries from './queries';

const EditTemplateMessageInput = ({
  template,
  deselectTemplate,
  nameInput,
}) => {
  const { messageInputText, attached } = useContext(MessageInputContext);
  const queryClient = useQueryClient();
  const updateTemplateMutation = useMutation(
    async () =>
      templatesAPI.update({
        content: messageInputText.current.innerHTML,
        attachments: attached,
        _id: template._id,
        name: nameInput.current.innerHTML,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(templateQueries.keyFactories.all());
        setTemplateSavedMessage(
          `Successfully updated template '${nameInput.current.innerHTML}'`,
        );
        deselectTemplate();
      },
    },
  );
  const deleteTemplateMutation = useMutation(
    async () => templatesAPI.delete(template),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(templateQueries.keyFactories.all());
        deselectTemplate();
      },
    },
  );
  const [templateSavedMessage, setTemplateSavedMessage] = useState(null);
  useEffect(() => {
    if (template && templateSavedMessage) {
      setTemplateSavedMessage(null);
    }
  }, [template]);

  const padding = '1.5rem';

  if (!template) {
    return (
      <div style={{ width: '95%' }}>
        {templateSavedMessage ? (
          <Alert severity='success'>{templateSavedMessage}</Alert>
        ) : null}
        <p style={{ textAlign: 'center', padding }}>
          {' '}
          Select a template to edit{' '}
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding }}>
      <h2
        ref={nameInput}
        contentEditable='true'
        className='h4 message-input__wrapper'
      />
      <MessageInput
        inboxMaxHeight='60vh'
        style={{ borderTop: 0 }}
        actionTriggers={
          <>
            <PrimaryButton
              onClick={() => {
                updateTemplateMutation.mutate();
              }}>
              Save changes
            </PrimaryButton>
            <SecondaryButton onClick={() => deselectTemplate()}>
              Cancel
            </SecondaryButton>
            <IconButton
              style={{ marginLeft: '4rem' }}
              onClick={e => {
                e.preventDefault();
                e.cancelBubble = true;
                confirm(
                  `Are you sure you wish to delete the template '${template.name}'`,
                  async () => {
                    await deleteTemplateMutation.mutate();
                  },
                  () => {},
                );
              }}
              icon={<IconTrashcan />}
              title='Delete template'
            />
          </>
        }
      />
    </div>
  );
};

export default EditTemplateMessageInput;
